import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary.jsx";
import App from './App.jsx';
import './i18n/i18n';
import './index.css';
import './styles/funnelMobile.css';

const canonicalHosts = new Set(['start-us.com', 'www.start-us.com']);
const shouldUpgradeToHttps =
  import.meta.env.PROD &&
  window.location.protocol === 'http:' &&
  canonicalHosts.has(window.location.hostname);

if (shouldUpgradeToHttps) {
  const secureUrl = new URL(window.location.href);
  secureUrl.protocol = 'https:';
  window.location.replace(secureUrl.toString());
} else {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <GlobalErrorBoundary>
        <App />
      </GlobalErrorBoundary>
    </StrictMode>,
  );
}
